<template lang="pug">
.app-drawer__wrapper(
  :class="{ minify: !expand && !preventStyles, prevent: preventStyles }"
)
  .app-card.app-drawer(
    v-if="!preventStyles"
    :style="drawerStyles"
  )
    .app-drawer__header
      v-btn.app-drawer__expand-btn(
        min-width="40"
        height="40"
        dark
        color="redesignPrimary"
        @click="expand = !expand"
      ): v-icon.btn-arrow(
        :class="{ 'btn-arrow__minify-state': !expand }"
      ) $ichevron-left
    portal-target(
      v-if="expand"
      name="subdrawer"
    )
  .redesignControlsBackground.full-width.sticky.py-4(v-else)
    portal-target(
      name="subdrawer"
    )
</template>

<script>
export default {
  name: 'AppDrawer',

  data() {
    return {
      expand: true,
      headerHeight: 88,
    };
  },

  computed: {
    preventStyles() {
      const { preventLayoutTemplate } = this.$route.meta;
      return preventLayoutTemplate;
    },
    drawerStyles() {
      return {
        height: this.expand ? `calc(100vh - ${this.headerHeight}px - 32px)` : '72px',
        width: this.expand ? '324px' : '72px',
        marginTop: `${this.headerHeight + 16}px`,
        padding: this.expand ? '32px' : '16px',
      };
    },
  },

  mounted() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  },

  methods: {
    getHeaderHeight() {
      const header = document.getElementById('app-header');
      return header?.getBoundingClientRect()?.height || 0;
    },

    resizeHandler() {
      this.headerHeight = this.getHeaderHeight();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-drawer {
  position: fixed;
  top: 0;
  margin-left: 16px;
  transition: all 0.2s;
  z-index: 2;
  overflow: auto;
  &__header {
    display: flex;
  }
  &__expand-btn {
    margin-left: auto;
    padding: 0 !important;

    border-radius: 20px;
  }
  &__wrapper {
    max-width: 340px;
    width: 100%;
    transition: all 0.2s;
    &.minify {
      max-width: 0px;
      margin-right: 30px;
    }
    &.prevent {
      position: relative;
      min-height: 100vh;
      background: #{$redesignControlsBackground};
      border-right: 2px solid #{$redesignBackground} !important;
    }
  }
}
.btn-arrow {
  transition: all 0.4s;

  &__minify-state {
    transform: rotateZ(180deg);
  }
}
</style>
